import {about_us_bg} from "../../assets/images";
import styled from 'styled-components';
import Navigation from "../navigation/header"
import MissionVisionSection from "./mission"
import CTASection from "../landing/landing_home/empower"
import TestimonialsSection from "../landing/landing_home/testimonial"
import Footer from "../Footer/footer"

const HeroContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 420px;
  overflow: hidden;
  position: relative;
  padding: 90px 20px 40px;

  background: 
  linear-gradient(
    to bottom,
    rgba(16, 12, 24, 0) 0%,
    rgba(16, 12, 24, 0.28) 35%,
    rgba(16, 12, 24, 0.46) 55%,
    rgba(16, 12, 24, 0.62) 100%
  ),
    url(${about_us_bg}) top center / cover no-repeat;

  background-blend-mode: normal;

  > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 640px) {
    padding: 20px 16px;
    height: 520px;
    
  background: linear-gradient(
      to bottom,
      rgba(96, 145, 251, 0) 0%,       /* Transparent at top */
      rgba(96, 145, 251, 0.31) 60%,    /* Slight gradient mid-way */
      rgba(99, 34, 249, 0.49) 100%     /* Deep purple at bottom */
    ), url(${about_us_bg}) top right / cover no-repeat;
  }
`;


const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 939px;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  @media (max-width: 991px) {
    max-width: 700px;
    gap: 28px;
  }

  @media (max-width: 640px) {
    gap: 24px;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

const MainHeading = styled.h1`
  width: 100%;
  color: #fff;
  text-align: center;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: -0.6px;
  font: 700 60px/70px 'Inter', sans-serif;
  margin: 0;

  @media (max-width: 991px) {
    font-size: 48px;
    line-height: 56px;
  }

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -0.4px;
  }
`;

const Subtitle = styled.p`
  color: #fff;
  text-align: center;
  letter-spacing: -0.08px;
  font: 500 16px/160% 'Inter', sans-serif;
  text-shadow: 0 1px 2px rgba(0,0,0,.45);
  margin: 0;

  @media (max-width: 640px) {
    font-size: 14px;
    line-height: 150%;
  }
`;


const AboutUs = () => {

  return (
    <>
      <Navigation />
      <HeroContainer>
      <ContentWrapper>
        <TextContent>
          <MainHeading>
            Empowering Students with 24/7 Chat Support
          </MainHeading>
          <Subtitle>
           Campus Insights helps educational institutions solve key challenges with AI-powered analytics and engagement tools—delivering timely information to boost student success, retention, and smart decision-making.
          </Subtitle>
        </TextContent>
       
       
      </ContentWrapper>
    </HeroContainer>
    <MissionVisionSection/>
    <TestimonialsSection/>
    <CTASection />
      <Footer />
    </>
  );
};


export default AboutUs;
